import { Contact } from "../store/config";
import * as api from "./api";

interface ApiResponse {
  status: number;
  message: string;
  data: Contact[];
  meta: {
    totalItems: number;
    itemsPerPage: number;
    totalPages: number;
    currentCount: number;
  };
}

const getAuthToken = () => {
  return localStorage.getItem("token") || "{}";
};

// fetch list
export const fetchContactList = async (data: {
  page: number;
  limit: number;
}): Promise<ApiResponse> => {
  const params = {
    page: data.page,
    limit: data.limit,
  };
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  const response: any = await api.get("/contact-us", params);
  return response;
};

// delete query
export const deleteContact = (id: string) => {
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  return api.remove(`/contact-us/${id}`);
};
